import { inject, Injectable } from '@angular/core';
import { InteractionType } from '../models/interaction-type.model';
import { DatabaseService, type QuerySignal } from './database.service';

/**
 * Read access to the org's interaction type list. Seeded in customer.sql; the
 * admin CRUD screen arrives in a later phase.
 */
@Injectable({
  providedIn: 'root',
})
export class InteractionTypeService {
  private db = inject(DatabaseService);

  /** Active, non-deleted types in display order. */
  async getActive(): Promise<InteractionType[]> {
    await this.db.init();
    const rows = await this.db.exec(
      'SELECT * FROM interaction_types WHERE is_active = 1 AND deleted_at IS NULL ORDER BY sort_order, label',
    );
    return rows as InteractionType[];
  }

  /** Every non-deleted type, active or not — for rendering historical rows. */
  async getAll(): Promise<InteractionType[]> {
    await this.db.init();
    const rows = await this.db.exec(
      'SELECT * FROM interaction_types WHERE deleted_at IS NULL ORDER BY sort_order, label',
    );
    return rows as InteractionType[];
  }

  createActiveQuery(): QuerySignal<InteractionType[]> {
    return this.db.createQuery('interaction_types', () => this.getActive());
  }

  createQuery(): QuerySignal<InteractionType[]> {
    return this.db.createQuery('interaction_types', () => this.getAll());
  }
}
